import { createClient } from '@supabase/supabase-js'
import env from '../config/environment'

// Supabase 클라이언트를 환경 변수로부터 생성
export const supabase = env.supabaseUrl && env.supabaseAnonKey 
  ? createClient(env.supabaseUrl, env.supabaseAnonKey)
  : null as any

// 회원가입
export async function signUp(email: string, password: string, fullName: string) {
  // 1. Supabase 회원가입
  const { data: authData, error: authError } = await supabase.auth.signUp({
    email,
    password,
    options: {
      data: {
        full_name: fullName
      }
    }
  })

  if (authError) throw authError

  // 2. 프로필 생성 (환경별 profiles 테이블)
  if (authData.user) {
    const tablePrefix = env.isProduction ? 'P_' : 'D_';
    const { error: profileError } = await supabase
      .from(`${tablePrefix}profiles`)
      .insert({
        id: authData.user.id,
        email: authData.user.email,
        full_name: fullName
      })

    if (profileError) throw profileError
  }

  return authData
}

// 로그인
export async function signIn(email: string, password: string) {
  const { data, error } = await supabase.auth.signInWithPassword({
    email,
    password
  })

  if (error) throw error
  return data
}

// 로그아웃
export async function signOut() {
  const { error } = await supabase.auth.signOut()
  if (error) throw error
}

// 현재 사용자
export async function getCurrentUser() {
  const { data: { user } } = await supabase.auth.getUser()
  return user
}

// 세션 체크
export async function getSession() {
  const { data: { session } } = await supabase.auth.getSession()
  return session
}